/* eslint-disable */
import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App'
import router from "./router/index.js"
import  "./common/stylus/index.styl" //引入一些基本的样式
import VueResource from 'vue-resource'
import 'ant-design-vue/dist/antd.css'
import Antd from 'ant-design-vue'
import ElementUI from 'element-ui'
import 'core-js/stable'
import md5 from 'js-md5'
import JsonExcel from 'vue-json-excel'
import base from './components/_util/base'//引用
import moment from 'moment';
import locale from 'ant-design-vue/lib/locale-provider/zh_CN';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');

Vue.prototype.$md5 = md5
Vue.prototype.$baseUrl = process.env.VUE_APP_BASE_URL
Vue.prototype.$uploadUrl = process.env.VUE_APP_BASE_URL+'fileUpload'


import QuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.bubble.css'
import 'quill/dist/quill.snow.css'




Vue.use(QuillEditor)
Vue.use(VueRouter)
Vue.use(VueResource)
Vue.use(Antd)
Vue.use(ElementUI)
Vue.component('downloadExcel', JsonExcel)
Vue.use(base);//将全局函数当做插件来进行注册
 // Vue.use(VueAxios);


new Vue({
  el: '#app',
  router,  // 注入到根实例中
  render: h => h(App)
})




// WEBPACK FOOTER //
// ./src/main.js